import { render } from "./LinkedinComponent.vue?vue&type=template&id=dd778cea&scoped=true"
import script from "./LinkedinComponent.vue?vue&type=script&lang=js"
export * from "./LinkedinComponent.vue?vue&type=script&lang=js"

import "./LinkedinComponent.vue?vue&type=style&index=0&id=dd778cea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd778cea"]])

export default __exports__